import React, { ButtonHTMLAttributes, FC, useEffect, useState } from 'react';
import {Link, Redirect, Route, Switch, useHistory} from 'react-router-dom';
import { DirectoryBar } from '../../components/DirectoryBar';
import {ReactComponent as PhoneIcon} from "../../assets/svg/icon-phone.svg";
import {ReactComponent as SendIcon} from "../../assets/svg/icon-send.svg";
import {Section} from "../../components/Section";
import {H3} from "../../components/H3";
import {AccordionCustom} from "../../components/AccordionCustom2";
import { Bridge } from '../../plugins/bridge';
import { ContentInfoEventProperties, ContentTabEventProperties } from '../../types/amplitudeEventProperties';
import { BRAZE_EVENT } from '../../constants/braze';
import Spinner from '../../components/Spinner';

function outlet_clicked(outlet_name : string) {
  const content = {
    content_tab : "매장",
    content_id : outlet_name,
    content_name : outlet_name
  }

  Bridge.sendAmplitude('content_clicked', content);
  Bridge.sendBraze(BRAZE_EVENT.CONTENT_ITEM_CLICKED, content);

}

const STOCKdata = [
  {
    id: 1,
    titleTop: '공식 판매처',
    stock: [
      {
        id: 1,
        title: '굿럭',
        address: '– 충청북도 청주시 상당구 교서로 16-5 1층',
        number: '043-221-2015',
        slash:'– ',
        site: 'goodluckstore.co.kr',
      },
      {
        id: 2,
        title: '리리 스토어',
        address: '– 서울시 용산구 한강대로7길 18-13 1층',
        number: '02-749-6003',
        slash:'– ',
        site: 'reelee.co.kr',
      },
      {
        id: 3,
        title: '더 바운스 - 상수',
        address: '– 서울시 마포구 독막로 92번지 공감빌딩 1,2층',
        number: '02-322-2296',
        slash:'– ',
        site: 'thebounce.co.kr',
      },
      {
        id: 4,
        title: '더 바운스 - AK 플라자 수원',
        address: '– 경기 수원시 팔달구 덕영대로 924 AK 플라자 1층',
        number: '031-240-2243',
        slash:'– ',
        site: 'thebounce.co.kr',
      },
      {
        id: 5,
        title: '잼스토어 바이 더엑스샵',
        address: '– 대구광역시 중구 동성로2길 50-8 2층',
        number: '070-7621-3177',
        slash:'– ',
        site: 'thexshop.co.kr',
      },
      {
        id: 6,
        title: `더 엑스 샵 - 대전`,
        address: '– 대전광역시 대종로488번길 39',
        number: '070-7720-3177',
        slash:'– ',
        site: 'thexshop.co.kr',
      },
      {
        id: 7,
        title: '더 엑스 샵 - 전주',
        address: '– 전라북도 전주시 완산구 전주객사4길 43',
        number: '070-7715-3177',
        slash:'– ',
        site: 'thexshop.co.kr',
      },
      {
        id: 8,
        title: '럼스토어',
        address: '– 충청남도 천안시 동남구 먹거리10길 32',
        number: '070-7566-2114',
        slash:'– ',
        site: 'lumbstore.com',
      },
      {
        id: 9,
        title: '에이트디비젼',
        address: '– 서울특별시 중구 퇴계로18길 31',
        number: '070-4135-0038',
        slash:'– ',
        site: '8division.com',
      },
      {
        id: 10,
        title: '엘카르텔',
        number: '02-753-0926',
        slash:'– ',
        site: 'elkartel.co.kr',
      },
      {
        id: 11,
        title: '케이스스터디 - 강남',
        address: '– 서울 서초구 신반포로 176',
        number: '1588-1234',
      },
      {
        id: 12,
        title: '케이스스터디 - 청담',
        address: '– 서울특별시 강남구 압구정로60길 21',
        number: '02-2056-1221',
      },
      {
        id: 13,
        title: '트리플 스토어',
        address: '– 제주 제주시 중앙로 246-1',
        number: '070-4200-5545',
        slash:'– ',
        site: 'triplestore.co.kr',
      },
      {
        id: 14,
        title: '트리플 엑스',
        address: '– 광주광역시 동구 충장로안길 7',
        number: '062-236-5559',
        slash:'– ',
        site: 'triple-x.kr',
      },
      {
        id: 15,
        title: '프레이트',
        address: '– 서울특별시 강남구 논현로159길 54 1층',
        number: '070-4221-1121',
        slash:'– ',
        site: 'fr8ight.co.kr',
      },
      {
        id: 16,
        title: '피어 - 더현대 서울',
        address: '– 서울특별시 영등포구 여의대로 108',
        number: '02-3277-0844',
      },
      {
        id: 17,
        title: '피어 - 판교',
        address: '– 경기도 성남시 분당구 판교역로146번길 20 현대백화점 판교점',
        number: '031-5170-2233',
      },
    ],
  },
];
export const OutletsPage = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(false);
    const contentEventProperties : ContentTabEventProperties = {
      content_tab : "매장"
    }
    Bridge.sendAmplitude('content_list_page_viewed', contentEventProperties);  
  }, []);

  return (
      <>
        <DirectoryBar text="홈, 매장" />
        {loading ? (<Spinner/>) : (
            <div className="bodyclass -mx-4 -mt-4 grid md:grid-cols-2 grid-cols-1">
              <div className="sic_2_l">
                {/*<p>APGUJEONG</p>*/}
                <Link to="/apgujeongdetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 서울 압구정")}}>
                  <img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-apgujeong.jpeg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 서울 압구정
                  </h2>
                  <h3>
                    서울특별시 강남구 압구정로 <br/> 54길 21 신우빌딩 1층
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:025410870"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a target="_blank" href="https://google.com/maps/place/Carhartt+WIP+Store+Seoul+Apgujeong/@37.5263987,127.0373305,17z/data=!3m1!4b1!4m5!3m4!1s0x357ca3886561e2ad:0x944c064c29728ccd!8m2!3d37.5263987!4d127.0395192?hl=ko"><SendIcon /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 02-541-0870<br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>12:00 - 21:00</span><br/>
                    화요일 <span>12:00 - 21:00</span><br/>
                    수요일 <span>12:00 - 21:00</span><br/>
                    목요일 <span>12:00 - 21:00</span><br/>
                    금요일 <span>12:00 - 21:00</span><br/>
                    토요일 <span>12:00 - 21:00</span><br/>
                    일요일 <span>12:00 - 21:00</span>
                  </h3>
                </div>
              </div>
              <div className="sic_2_r">
                {/*<p>HONGDAE WAUSAN</p>*/}
                <Link to="/hongdaedetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 서울 홍대 와우산")}}><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-hongdae.jpeg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 서울 홍대 와우산
                    {/*CARHARTT WIP STORE SEOUL HONGDAE WAUSAN*/}
                  </h2>
                  <h3>
                    서울특별시 마포구 와우산로<br/> 52 1층 ~ 2층
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:023378333"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a target="_blank" href="https://google.com/maps/place/%EC%B9%BC%ED%95%98%ED%8A%B8WIP+%ED%99%8D%EB%8C%80+%EC%99%80%EC%9A%B0%EC%82%B0/@37.549008,126.9210301,17z/data=!3m1!4b1!4m5!3m4!1s0x357ca2ed792ec989:0xe6f0bdf1d2bbda3b!8m2!3d37.549008!4d126.9232188?hl=ko"><SendIcon /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 02-337-8333<br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>12:00 - 21:00</span><br/>
                    화요일 <span>12:00 - 21:00</span><br/>
                    수요일 <span>12:00 - 21:00</span><br/>
                    목요일 <span>12:00 - 21:00</span><br/>
                    금요일 <span>12:00 - 21:00</span><br/>
                    토요일 <span>12:00 - 21:00</span><br/>
                    일요일 <span>12:00 - 21:00</span>
                  </h3>
                </div>
              </div>
              <div className="sic_2_r">
                {/*<p>SEOUL COEX MALL</p>*/}
                <Link to="/coexdetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 서울 코엑스몰")}}><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-coex.jpeg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 서울 코엑스몰
                    {/*CARHARTT WIP STORE SEOUL COEX MALL*/}
                  </h2>
                  <h3>
                    서울특별시 강남구 영동대로<br/>513 코엑스몰 F101
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:025515512"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a target="_blank" href="https://google.com/maps/place/%EC%B9%BC%ED%95%98%ED%8A%B8WIP+%EC%BD%94%EC%97%91%EC%8A%A4%EB%AA%B0%EC%A0%90+(Carhartt+WIP+Store+Seoul+COEX+MALL)/@37.509663,127.0525183,15z/data=!4m9!1m2!2m1!1sCarhartt+WIP+Store+Seoul+COEX+MALL!3m5!1s0x357ca46a9f10d8d1:0xb75978d0e4f7fee7!8m2!3d37.509663!4d127.061273!15sCiJDYXJoYXJ0dCBXSVAgU3RvcmUgU2VvdWwgQ09FWCBNQUxMIgOIAQFaJCIiY2FyaGFydHQgd2lwIHN0b3JlIHNlb3VsIGNvZXggbWFsbJIBDmNsb3RoaW5nX3N0b3Jl?hl=ko"><SendIcon /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 02-551-5512
                    <br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>10:30 - 22:00</span><br/>
                    화요일 <span>10:30 - 22:00</span><br/>
                    수요일 <span>10:30 - 22:00</span><br/>
                    목요일 <span>10:30 - 22:00</span><br/>
                    금요일 <span>10:30 - 22:00</span><br/>
                    토요일 <span>10:30 - 22:00</span><br/>
                    일요일 <span>10:30 - 22:00</span>
                  </h3>
                </div>
              </div>
              <div className="sic_2_r">
                {/*<p>SEOUL TIMES SQUARE</p>*/}
                <Link to="/timedetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 서울 타임스퀘어")}}><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-time.jpeg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 서울 타임스퀘어
                    {/*CARHARTT WIP STORE SEOUL TIMES SQUARE*/}
                  </h2>
                  <h3>
                    서울특별시 영등포구 영중로<br/> 15 타임스퀘어 3층
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:0226382701"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a target="_blank" href="https://google.com/maps/place/%EC%B9%BC%ED%95%98%ED%8A%B8WIP+%ED%83%80%EC%9E%84%EC%8A%A4%ED%80%98%EC%96%B4%EC%A0%90+(Carhartt+WIP+Store+Seoul+TIMES+SQUARE)/@37.5172946,126.9015008,17z/data=!3m2!4b1!5s0x357c9efb08010d7f:0x6d1d81e6681e16b4!4m5!3m4!1s0x357c9ff1001e00a9:0xd91a05325879eee8!8m2!3d37.5172946!4d126.9036895?hl=ko"><SendIcon /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 02-2638-2701
                    <br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>10:30 - 22:00</span><br/>
                    화요일 <span>10:30 - 22:00</span><br/>
                    수요일 <span>10:30 - 22:00</span><br/>
                    목요일 <span>10:30 - 22:00</span><br/>
                    금요일 <span>10:30 - 22:00</span><br/>
                    토요일 <span>10:30 - 22:00</span><br/>
                    일요일 <span>10:30 - 22:00</span>
                  </h3>
                </div>
              </div>
              <div className="sic_2_l">
                <Link to="/lottedetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 천안")}}><img src={"https://s3.ap-northeast-2.amazonaws.com/media.worksout.co.kr/resized/outlets/store-carhartt-13_resized.jpg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 롯데월드몰점
                  </h2>
                  <h3>
                    서울특별시 송파구 <br/>올림픽로 300 롯데월드몰 1층
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:0232134180"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 rounded-full grid place-content-center bg-gray-100 pointer-events-none">
                      <a target="_blank" href="https://google.com/maps/place/%EC%B9%BC%ED%95%98%ED%8A%B8WIP+%EC%B2%9C%EC%95%88%EC%A0%90/@36.8177563,127.1549999,17z/data=!3m1!4b1!4m5!3m4!1s0x357b2939b6d3b957:0xeeff902e5ab7ff4e!8m2!3d36.8177563!4d127.1571886?hl=ko"><SendIcon className={'fill-white'} /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 02-3213-4180
                    <br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>10:30 - 22:00</span><br/>
                    화요일 <span>10:30 - 22:00</span><br/>
                    수요일 <span>10:30 - 22:00</span><br/>
                    목요일 <span>10:30 - 22:00</span><br/>
                    금요일 <span>10:30 - 22:00</span><br/>
                    토요일 <span>10:30 - 22:00</span><br/>
                    일요일 <span>10:30 - 22:00</span><br/>
                    라스트오더 <span>21:30</span>
                  </h3>
                </div>
              </div>
              <div className="sic_2_l">
                {/*<p>CHEONAN</p>*/}
                <Link to="/cheonandetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 천안")}}><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-cheonan.jpg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 천안
                    {/*CARHARTT WIP STORE CHEONAN*/}
                  </h2>
                  <h3>
                    충청남도 천안시 동남구<br/>먹거리10길 32
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:0415520922"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a target="_blank" href="https://google.com/maps/place/%EC%B9%BC%ED%95%98%ED%8A%B8WIP+%EC%B2%9C%EC%95%88%EC%A0%90/@36.8177563,127.1549999,17z/data=!3m1!4b1!4m5!3m4!1s0x357b2939b6d3b957:0xeeff902e5ab7ff4e!8m2!3d36.8177563!4d127.1571886?hl=ko"><SendIcon /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 041-552-0922
                    <br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>12:00 - 21:00</span><br/>
                    화요일 <span>12:00 - 21:00</span><br/>
                    수요일 <span>12:00 - 21:00</span><br/>
                    목요일 <span>12:00 - 21:00</span><br/>
                    금요일 <span>12:00 - 21:00</span><br/>
                    토요일 <span>12:00 - 21:00</span><br/>
                    일요일 <span>12:00 - 21:00</span>
                  </h3>
                </div>
              </div>
              <div className="sic_2_r">
                {/*<p>GWANGJU</p>*/}
                <Link to="/gwangjudetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 광주")}}><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-gwangju.jpg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 광주
                    {/*CARHARTT WIP STORE GWANGJU*/}
                  </h2>
                  <h3>
                    광주광역시 동구 충장로<br/>74-1
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:0624330926"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a target="_blank" href="https://google.com/maps/place/%EC%B9%BC%ED%95%98%ED%8A%B8WIP%EA%B4%91%EC%A3%BC/@35.1488653,126.9129074,17z/data=!3m1!4b1!4m5!3m4!1s0x35718dfa2713b9fd:0xbcc48a1347022617!8m2!3d35.1488653!4d126.9150961?hl=ko"><SendIcon /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 062-433-0926
                    <br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>12:00 - 21:00</span><br/>
                    화요일 <span>12:00 - 21:00</span><br/>
                    수요일 <span>12:00 - 21:00</span><br/>
                    목요일 <span>12:00 - 21:00</span><br/>
                    금요일 <span>12:00 - 21:00</span><br/>
                    토요일 <span>12:00 - 21:00</span><br/>
                    일요일 <span>12:00 - 21:00</span>
                  </h3>
                </div>
              </div>
              <div className="sic_2_r">
                {/*<p>JEONJU</p>*/}
                <Link to="/jeonjudetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 전주")}}><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-jeonju.jpeg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 전주
                    {/*CARHARTT WIP STORE JEONJU*/}
                  </h2>
                  <h3>
                    전라북도 전주시 완산구<br/>전주객사4길 66
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:0632843177"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a target="_blank" href="https://google.com/maps/place/Carhartt+WIP+Store+Jeonju/@35.8201839,127.1413916,17z/data=!3m1!4b1!4m5!3m4!1s0x357023d332e298dd:0xbedc8c38c2dea20c!8m2!3d35.8201839!4d127.1435803?hl=ko"><SendIcon /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 063-284-3177
                    <br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>12:00 - 22:00</span><br/>
                    화요일 <span>12:00 - 22:00</span><br/>
                    수요일 <span>12:00 - 22:00</span><br/>
                    목요일 <span>12:00 - 22:00</span><br/>
                    금요일 <span>12:00 - 22:00</span><br/>
                    토요일 <span>12:00 - 22:00</span><br/>
                    일요일 <span>12:00 - 22:00</span>
                  </h3>
                </div>
              </div>


              <div className="sic_2_r">
                {/*<p>DAEGU</p>*/}
                <Link to="/daegudetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 대구")}}><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-daegu.jpeg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 대구
                    {/*CARHARTT WIP STORE DAEGU*/}
                  </h2>
                  <h3>
                    대구광역시 동구 동부로<br/>149 신세계백화점 대구점 6층
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:0536616593"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a target="_blank" href="https://google.com/maps/place/%EC%B9%BC%ED%95%98%ED%8A%B8WIP+%EB%8C%80%EA%B5%AC%EC%8B%A0%EC%84%B8%EA%B3%84%EB%B0%B1%ED%99%94%EC%A0%90+(Carhartt+WIP+Store+Daegu+Shinsegae+Department+store)/@35.877339,128.6263383,17z/data=!3m1!4b1!4m5!3m4!1s0x3565e18d91b0a203:0xd83fc22541a2c8d5!8m2!3d35.877339!4d128.628527?hl=ko"><SendIcon /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 053-661-6593
                    <br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>10:30 - 20:00</span><br/>
                    화요일 <span>10:30 - 20:00</span><br/>
                    수요일 <span>10:30 - 20:00</span><br/>
                    목요일 <span>10:30 - 20:00</span><br/>
                    금요일 <span>10:30 - 20:30</span><br/>
                    토요일 <span>10:30 - 20:30</span><br/>
                    일요일 <span>10:30 - 20:30</span>
                  </h3>
                </div>
              </div>

              <div className="sic_2_l">
                {/*<p>DAEGU DONGSEONGRO</p>*/}
                <Link to="/dongseongrodetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 동성로")}}><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-dongseongro.jpeg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 대구 동성로
                    {/*CARHARTT WIP STORE DAEGU DONGSEONGRO*/}
                  </h2>
                  <h3>
                    대구광역시 중구 동성로1길<br/> 29-31
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:0534240922"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a target="_blank" href="https://google.com/maps/place/%EC%B9%BC%ED%95%98%ED%8A%B8WIP+%EB%8C%80%EA%B5%AC+%EB%8F%99%EC%84%B1%EB%A1%9C/@35.867786,128.5930381,17z/data=!3m1!4b1!4m5!3m4!1s0x3565e32a01399847:0x47a3873de4a6709d!8m2!3d35.867786!4d128.5952268?hl=ko"><SendIcon /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 053-424-0922
                    <br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>12:00 - 21:00</span><br/>
                    화요일 <span>12:00 - 21:00</span><br/>
                    수요일 <span>12:00 - 21:00</span><br/>
                    목요일 <span>12:00 - 21:00</span><br/>
                    금요일 <span>12:00 - 22:00</span><br/>
                    토요일 <span>12:00 - 22:00</span><br/>
                    일요일 <span>12:00 - 22:00</span>
                  </h3>
                </div>
              </div>
              <div className="sic_2_l">
                {/*<p>JEJU</p>*/}
                <Link to="/jejudetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 제주")}}><img src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/storeInfo/store-carhartt-jeju.jpeg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 제주
                    {/*CARHARTT WIP STORE JEJU*/}
                  </h2>
                  <h3>
                    제주특별자치도 제주시 중앙로7길<br/>11-1
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:0647025545"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a target="_blank" href="https://google.com/maps/place/%EC%A0%9C%EC%A3%BC%ED%8A%B9%EB%B3%84%EC%9E%90%EC%B9%98%EB%8F%84+%EC%A0%9C%EC%A3%BC%EC%8B%9C+%EC%A4%91%EC%95%99%EB%A1%9C7%EA%B8%B8+11-1/@33.5149695,126.5238916,17z/data=!3m1!4b1!4m5!3m4!1s0x350ce356f3730fa5:0x95e9569976386047!8m2!3d33.5149695!4d126.5260803?hl=ko"><SendIcon /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 064-702-5545
                    <br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>11:00 - 21:00</span><br/>
                    화요일 <span>11:00 - 21:00</span><br/>
                    수요일 <span>11:00 - 21:00</span><br/>
                    목요일 <span>11:00 - 21:00</span><br/>
                    금요일 <span>11:00 - 21:00</span><br/>
                    토요일 <span>11:00 - 21:00</span><br/>
                    일요일 <span>11:00 - 21:00</span>
                  </h3>
                </div>
              </div>
              <div className="sic_2_r">
                {/*<p>BUSAN</p>*/}
                <Link to="/centumdetail"
                      onClick={()=>{outlet_clicked("칼하트윕 스토어 부산 센텀시티")}}><img src={"https://s3.ap-northeast-2.amazonaws.com/media.worksout.co.kr/resized/outlets/store-carhartt-10-0.jpg"} alt="" /></Link>
                <div className="sic_2_txt">
                  <h2>칼하트윕 스토어 부산 센텀시티
                    {/*CARHARTT WIP STORE BUSAN CENTUM CITY MAL*/}
                  </h2>
                  <h3>
                    부산광역시 해운대구 센텀남대로 35<br/>신세계백화점센텀시티 B2층
                  </h3>
                  <div className="o_button">
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a href="tel:0517452961"><PhoneIcon /></a>
                    </button>
                    <button className="wh-9 border-gray-300 border rounded-full grid place-content-center">
                      <a target="_blank" href="https://google.com/maps/place/Carhartt+WIP+Corner+Busan+Centum+City+Mall/@35.156853,129.0544583,17z/data=!3m1!4b1!4m5!3m4!1s0x3568eb6e1675e00f:0x26805caac4f14d9d!8m2!3d35.156853!4d129.056647?hl=ko"><SendIcon /></a>
                    </button>
                  </div>
                  <br/>
                  <h2>매장정보</h2>
                  <h3>
                    전화번호: 051-745-2961
                    <br/>
                  </h3>
                  <br/>
                  <h2>운영시간</h2>
                  <h3>
                    월요일 <span>10:30 - 20:00</span><br/>
                    화요일 <span>10:30 - 20:00</span><br/>
                    수요일 <span>10:30 - 20:00</span><br/>
                    목요일 <span>10:30 - 20:00</span><br/>
                    금요일 <span>10:30 - 20:30</span><br/>
                    토요일 <span>10:30 - 20:30</span><br/>
                    일요일 <span>10:30 - 20:30</span>
                  </h3>
                </div>
              </div>
              <div className="sic_2_r w-full">
                <div className="stock_0">
                  {STOCKdata.map(section => (
                      <Section>
                        <H3 className="stock_1">{section.titleTop}</H3>
                        {section.stock.map(stockist => (
                            <>
                              <AccordionCustom
                                  title={
                                    <>
                                      <h1 className="stock_2">
                                        {stockist.title}
                                      </h1>
                                    </>
                                  }
                                  content={
                                    <>
                                      <div className="stock_3 flex flex-col">
                                        <span>{stockist.address}</span>
                                        <span>– {stockist.number}</span>
                                        <button
                                            onClick={() => {
                                              window.open(`http://${stockist.site}`, '_blank');
                                            }}
                                            className="break-all text-left"
                                        >
                                          {stockist.slash}
                                          {stockist.site}
                                        </button>
                                      </div>
                                    </>
                                  }
                                  defaultExpanded={false}
                              />
                            </>
                        ))}
                      </Section>
                  ))}
                </div>
              </div>
            </div>
        )}
      </>
  );
};


